import React from 'react';
import { AgentSelectionContainer } from './components/agent-selection';
import { SparkflowContainer } from './components/sparkflow-container';
import { SpotbuildIntegration } from './components/spotbuild-integration/spotbuild-integration.container';
import { UseCaseContainer } from './components/use-case/use-case.container';
const baseRoutes = {
    Root: {
        path: '',
        element: React.createElement(SparkflowContainer, null),
    },
    AgentSelection: {
        path: 'agent-selection',
        element: React.createElement(AgentSelectionContainer, null),
    },
    SpotbuildIntegration: {
        path: 'build',
        element: React.createElement(SpotbuildIntegration, null),
    },
    UseCase: {
        path: 'use-case',
        element: React.createElement(UseCaseContainer, null),
    },
};
export const ROUTES = baseRoutes;
export const addRootPathToRouteObject = (Routes, rootPath) => {
    return Routes.map((ele) => {
        return {
            ...ele,
            path: rootPath + ele.path,
        };
    });
};
//# sourceMappingURL=routes.js.map